import { ComponentPropsWithoutRef } from 'react';
import Image from 'next/image';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Libs
import { FAQArticleType } from '@/lib/home/FAQList';

import Button from '@/components/base/Button';
// Components
import LinkBase from '@/components/base/LinkBase';

const FAQArticle = ({
    faqArticle,
    ...restProps
}: ComponentPropsWithoutRef<'div'> & { faqArticle: FAQArticleType }) => {
    const { t } = useTranslation('home');

    return (
        <div
            className="col-span-2 rounded-md bg-white dark:bg-icoDarkMode-anthracite lg:col-span-1"
            {...restProps}>
            <div className="flex h-full flex-col p-5">
                <div className="mb-5 flex items-center space-x-2">
                    <Image
                        src={faqArticle?.authorPhoto}
                        alt={faqArticle?.author}
                        width={400}
                        height={400}
                        style={{ objectFit: 'cover' }}
                        className="h-10 w-10 rounded-full"
                    />
                    <div className="flex flex-col space-y-1">
                        <p className="font-GSemiBold text-xs text-icoBlue">
                            {t('faq.faq_article')}
                        </p>
                        <p className="font-GMedium text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                            {t('faq.written_by', { author: faqArticle?.author })}
                        </p>
                    </div>
                </div>
                <p className="mb-2 line-clamp-2 w-full font-GBold text-sm text-icoBlack dark:text-white">
                    {t(faqArticle?.title)}
                </p>
                <p className="mb-5 line-clamp-3 w-full font-GMedium text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {t(faqArticle?.text)}
                </p>
                <LinkBase href={faqArticle?.link} target="_blank" className="mt-auto w-min">
                    <Button size="sm" variant="secondary">
                        {t('cta_read_more')}
                    </Button>
                </LinkBase>
            </div>
        </div>
    );
};

export default FAQArticle;
